module.exports = __webpack_public_path__ + "img/bank.e346a440.svg";